<template>
  <div class="w-full ">
    <button
      @click="dialog = true"
      class="view-more transition-all duration-300 ease w-full text-xl capitalize text-center md:text-left hover:underline py-3 font-medium bg-[#3c3168] hover:bg-[#ffffff26] hover:font-semibold"
    >
      <slot></slot>
    </button>

    <v-dialog v-model="dialog" transition="dialog-top-transition">
      <v-card>
        <v-card-text>
          <div class="bg-white px-0 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="sm:flex sm:items-start">
              <div class="mt-3 w-full text-center sm:mt-0  sm:text-left">
                <div
                  class=" sm:text-center  sm:px-0 mb-4 flex flex-row items-center justify-between"
                >
                  <h3 class="text-lg font-medium leading-6 text-gray-700">
                    {{ tcc.taxpayer }}
                  </h3>
                  <button
                    @click="dialog = false"
                    type="button"
                    class="transition-all duration-100 ease-linear  text-xl hover:text-red-600 font-bold text-gray-400  outline-none "
                  >
                    <i class="far fa-times-circle"></i>
                  </button>
                </div>
                <div
                  class="sm:block hidden w-full overflow-x-hidden overflow-y-auto pr-0 sm:pr-6"
                >
                  <table class="table p-4 bg-white shadow rounded-lg">
                    <thead>
                      <tr class="">
                        <th
                          class="text-left border p-4 dark:border-dark-5 whitespace-nowrap bg-gray-100 font-semibold text-gray-700"
                        >
                          Year
                        </th>
                        <th
                          class="text-left border p-4 dark:border-dark-5 whitespace-nowrap bg-gray-100 font-semibold text-gray-700"
                        >
                          Income
                        </th>
                        <th
                          class="text-left border p-4 dark:border-dark-5 whitespace-nowrap bg-gray-100 font-semibold text-gray-700"
                        >
                          Tax Paid
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="text-gray-700 text-left text-sm">
                        <td class="text-left border p-4 dark:border-dark-5">
                          {{ tcc.year1 }}
                        </td>
                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left  sm:w-40 ">
                            {{ formatAmount(tcc.total_income_year1) }}
                          </div>
                        </td>
                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left sm:w-40">
                            {{ formatAmount(tcc.taxpayable_year1) }}
                          </div>
                        </td>
                      </tr>
                      <tr class="text-gray-700 text-left text-sm">
                        <td class="text-left border p-4 dark:border-dark-5">
                          {{ tcc.year2 }}
                        </td>
                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left  sm:w-40 ">
                            {{ formatAmount(tcc.total_income_year2) }}
                          </div>
                        </td>
                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left sm:w-40">
                            {{ formatAmount(tcc.taxpayable_year2) }}
                          </div>
                        </td>
                      </tr>
                      <tr class="text-gray-700 text-left text-sm">
                        <td class="text-left border p-4 dark:border-dark-5">
                          {{ tcc.year3 }}
                        </td>
                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left  sm:w-40 ">
                            {{ formatAmount(tcc.total_income_year3) }}
                          </div>
                        </td>
                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left sm:w-40">
                            {{ formatAmount(tcc.taxpayable_year3) }}
                          </div>
                        </td>
                      </tr>
                      <!-- <tr
                        class="text-gray-700 font-semibold bg-gray-100 text-left"
                      >
                        <td class="text-left border p-4 dark:border-dark-5">
                          Total
                        </td>
                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left  w-40 ">
                            {{ totalIncome(tcc) }}
                          </div>
                        </td>
                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left w-40">
                            {{ formatAmount(tcc.amount) }}
                          </div>
                        </td>
                      </tr> -->
                      <!-- <tr>
                                <td colspan="4" class="w-full py-4 px-4 border-2 border-gray-200 bg-gray-100 ">
                                    <div class="flex flex-row space-x-10">
                                        <div
                                            class=" flex flex-row items-center text-left text-md leading-5 text-gray-700 font-semibold">
                                            {{totalIncome(tcc)}}
                                        </div>
                                        <div
                                            class=" flex flex-row items-center text-left text-md leading-5 text-gray-700 font-semibold">
                                            {{formatAmount(tcc.amount)}}
                                        </div>
                                    </div>
                                </td>
                            </tr> -->
                    </tbody>
                  </table>
                </div>

                <div
                  class="sm:hidden block w-full h-96 overflow-x-hidden overflow-y-auto pr-0 sm:pr-6"
                >
                  <table class="table p-4 w-full bg-white shadow rounded-lg">
                    <thead>
                      <tr class="">
                        <th
                          class="text-left border p-4 dark:border-dark-5 whitespace-nowrap bg-gray-100 font-semibold text-gray-700"
                        >
                          Year
                        </th>
                        <th
                          class="text-left border p-4 dark:border-dark-5 whitespace-nowrap bg-gray-100 font-semibold text-gray-700"
                        >
                          Income
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="text-gray-700 text-left text-sm">
                        <td class="text-left border p-4 dark:border-dark-5">
                          {{ tcc.year1 }}
                        </td>
                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left  sm:w-40 ">
                            {{ formatAmount(tcc.total_income_year1) }}
                          </div>
                        </td>
                      </tr>
                      <tr class="text-gray-700 text-left text-sm">
                        <td class="text-left border p-4 dark:border-dark-5">
                          {{ tcc.year2 }}
                        </td>
                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left  sm:w-40 ">
                            {{ formatAmount(tcc.total_income_year2) }}
                          </div>
                        </td>
                      </tr>
                      <tr class="text-gray-700 text-left text-sm">
                        <td class="text-left border p-4 dark:border-dark-5">
                          {{ tcc.year3 }}
                        </td>
                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left  sm:w-40 ">
                            {{ formatAmount(tcc.total_income_year3) }}
                          </div>
                        </td>
                      </tr>
                      <!-- <tr
                        class="hidden d-none text-gray-700 font-semibold bg-gray-100 text-left"
                      >
                        <td class="text-left border p-4 dark:border-dark-5">
                          Total
                        </td>
                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left  w-40 ">
                            {{ totalIncome(tcc) }}
                          </div>
                        </td>
                      </tr> -->
                      <!-- <tr>
                                <td colspan="4" class="w-full py-4 px-4 border-2 border-gray-200 bg-gray-100 ">
                                    <div class="flex flex-row space-x-10">
                                        <div
                                            class=" flex flex-row items-center text-left text-md leading-5 text-gray-700 font-semibold">
                                            {{totalIncome(tcc)}}
                                        </div>
                                        <div
                                            class=" flex flex-row items-center text-left text-md leading-5 text-gray-700 font-semibold">
                                            {{formatAmount(tcc.amount)}}
                                        </div>
                                    </div>
                                </td>
                            </tr> -->
                    </tbody>
                  </table>
                  <table
                    class="table p-4 w-full bg-white shadow rounded-lg mt-6"
                  >
                    <thead>
                      <tr class="">
                        <th
                          class="text-left border p-4 dark:border-dark-5 whitespace-nowrap bg-gray-100 font-semibold text-gray-700"
                        >
                          Year
                        </th>

                        <th
                          class="text-left border p-4 dark:border-dark-5 whitespace-nowrap bg-gray-100 font-semibold text-gray-700"
                        >
                          Tax Paid
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="text-gray-700 text-left text-sm">
                        <td class="text-left border p-4 dark:border-dark-5">
                          {{ tcc.year1 }}
                        </td>

                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left sm:w-40">
                            {{ formatAmount(tcc.taxpayable_year1) }}
                          </div>
                        </td>
                      </tr>
                      <tr class="text-gray-700 text-left text-sm">
                        <td class="text-left border p-4 dark:border-dark-5">
                          {{ tcc.year2 }}
                        </td>

                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left sm:w-40">
                            {{ formatAmount(tcc.taxpayable_year2) }}
                          </div>
                        </td>
                      </tr>
                      <tr class="text-gray-700 text-left text-sm">
                        <td class="text-left border p-4 dark:border-dark-5">
                          {{ tcc.year3 }}
                        </td>

                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left sm:w-40">
                            {{ formatAmount(tcc.taxpayable_year3) }}
                          </div>
                        </td>
                      </tr>
                      <!-- <tr
                        class="d-none text-gray-700 font-semibold bg-gray-100 text-left"
                      >
                        <td class="text-left border p-4 dark:border-dark-5">
                          Total
                        </td>

                        <td class="border p-4 dark:border-dark-5">
                          <div class="text-left w-40">
                            {{ formatAmount(tcc.amount) }}
                          </div>
                        </td>
                      </tr> -->
                      <!-- <tr>
                                <td colspan="4" class="w-full py-4 px-4 border-2 border-gray-200 bg-gray-100 ">
                                    <div class="flex flex-row space-x-10">
                                        <div
                                            class=" flex flex-row items-center text-left text-md leading-5 text-gray-700 font-semibold">
                                            {{totalIncome(tcc)}}
                                        </div>
                                        <div
                                            class=" flex flex-row items-center text-left text-md leading-5 text-gray-700 font-semibold">
                                            {{formatAmount(tcc.amount)}}
                                        </div>
                                    </div>
                                </td>
                            </tr> -->
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <button
            @click="dialog = false"
            class=" w-full md:hidden inline-flex justify-center rounded-md border-2 border-gray-400 bg-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-500 hover:bg-gray-500 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Close
          </button>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import numeral from "numeral";
export default {
  props: {
    tcc: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    formatAmount(amt) {
      return "₦ " + numeral(amt).format("0,0.00");
    },
    totalIncome(request) {
      return this.formatAmount(
        request.total_income_year1 +
          request.total_income_year2 +
          request.total_income_year3
      );
    },
    isMobile() {
      return this.$vuetify.display.mobile;
    },
    getSize(size) {
      switch (size) {
        case "xs":
          return 220;
        case "sm":
          return 400;
        case "md":
          return 500;
        case "lg":
          return 600;
        case "xl":
          return 800;
        case "xxl":
          return 1200;
      }
    },
    isScreenGt(size) {
      let val = this.getSize(size);
      return window.screen.width >= val;
    },
  },
};
</script>

<style>
/* .view-more {
  color: white;
  box-sizing: border-box;
  padding: 0px;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-content: center;
  text-align: center;
  cursor: pointer;
  outline: none;
  margin-left: 7px;
  margin-top: 10px;
  margin-bottom: 10px;
  text-decoration: underline;
  font-weight: 800;
  transition: all 0.3s linear;
}

.view-more:hover {
  font-weight: 900;
  transform: scale(1.05);
} */

.modal {
  padding: 30px 20px;
}

@media screen and (min-width: 540px) {
  .v-dialog {
    width: auto !important;
  }
}
@media screen and (max-width: 540px) {
  .v-dialog {
    width: auto !important;
    box-shadow: none !important;
    overflow: hidden;
  }
  .v-dialog__content {
    height: 90vh !important;
    overflow-y: scroll !important;
  }
}
</style>
